import React, { useState } from 'react';
/* import logo from '../../img/logo_final_png.png'; */
import { Translate } from '../../language';
import { connect } from 'react-redux'
import { checkCodeReferal, cleanCodeReferal, sendRegisterUser } from '../../actions/regiterActions'
/* import Calendar from 'react-calendar'; */
/* import GetUbication from '../../containers/GetUbication';
import ModalTermsAndConditions from '../TermsAndConditions/ModalTermsAndConditions';
import ModalPictureProfile from '../../containers/ModalPictureProfile';
import { UploadImage } from './UploadFile'; */
import { fileUploadProfileImage } from '../../actions/fileUploadActions';
import ViewRegister from '../../containers/ViewRegister/ViewRegister'
import useModal from '../../utils/hooks/useModal';

const RegisterUser = ({ cleanCodeReferal,code,sendRegisterUser, history,checkCodeReferal }) => {
    // var email = "coreo@gmail.com"

    //var email = location.state.email
    const [picture, setPicture] = useState('')
    const [email, setEmail] = useState('')
    const [gender, setGender] = useState('')
    const [nameUser, setNameUser] = useState('')
    const [latsNameUser, setLatsNameUser] = useState('')
    const [password, setPassword] = useState('')
    const [ubication, setUbication] = useState('')
    const [file, setFile] = useState('')
    const [urlProfilePicture, seturlProfilePicture] = useState('')
    const [phone, setPhone] = useState("")
    const [referalcode, setReferalode] = useState("")
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState({})
    const [isAcceptTerms, setIsAcceptTerms] = useState(false)
    const [date, setDate] = useState(new Date())
    const [dateView, setDateView] = useState('')
    const [refVisibleCalendar, isVisibleCalendar, setIsVisibleCalendar] = useModal(false)
    const [isValidate, setValidate] = useState(false)
    const [isCodeReferal, setiIsCodeReferal] = useState(false)
    const [originCity, setOriginCity] = useState('')
    const [currentCity, setCurrentCity] = useState('')
    const [isShowModalTerms, setIsShowModalTerms] = useState(false)
    const [isShowPikerProfilePicture, setIsShowPikerProfilePicture] = useState(false)

    const checkCode = (code) => {
        checkCodeReferal(code)
    }
    const selectTerms = (e) => {
        e.stopPropagation()
        setIsShowModalTerms(!isShowModalTerms)
    }
    const selectPikerProfile = (e) => {
        e.stopPropagation()
        setIsShowPikerProfilePicture(!isShowPikerProfilePicture)
    }




    const onChange = dateTime => {
        const saveDate = new Date(dateTime)
        setDateView(saveDate.getDate() + '/' + (saveDate.getMonth() + 1) + '/' + saveDate.getFullYear())
        setDate(dateTime)
        setIsVisibleCalendar(false)
        console.log()
    }

    const isChecked = () => {
        setIsAcceptTerms(!isAcceptTerms)

        if (nameUser === '' || password === '' || confirmPassword === '' || dateView === '') {
            setValidate(false)
        }
        if (!isAcceptTerms) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: ''
            }));
        }

        var checkTermsOfServiceVar = 'checkTermsOfService'

        if (isAcceptTerms) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: Translate('isAcceptTerms', 'es')
            }));
        }


        if (dateView === '') {
            setValidate(false)

        }
    }

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {

        if (nameUser !== '' && dateView !== '' && password !== '' && confirmPassword !== '' && isAcceptTerms === true) {
           
            if(isCodeReferal && !code.valid){
                setValidate(false)
            }
            if(isCodeReferal && code.valid){
                setValidate(true)
            }
        }
    
        
        const { name, value } = e.target;
        if (name === "password")
            setPassword(value)
        if (name === "confirmPassword")
            setConfirmPassword(value)
        console.log()
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es')
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));

            if (name === "password" || name === "confirmPassword") {
                if (value.length < 6) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordToShort', 'es')
                    }));
                }

                if (value.length > 32) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordToLong', 'es')
                    }));
                }
            }

            else {

                setError(prevError => ({
                    ...prevError,
                    [name]: ''
                }));
            }

            if (name === "confirmPassword") {

                if (password !== confirmPassword) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordNoMatch', 'es')
                    }));
                }

            }

            if (name === "email") {
                if ((value.includes("@") && value.includes(".")) === false) {
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('invalidEmail', 'es')
                    }));
                }

            }
            
        }
        

    }

    var dateObj = new Date()
    var month = dateObj.getUTCMonth() + 1;
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var maxDateCalendar = new Date(year - 13, month, day);

    return (
        <ViewRegister
        code={code}
        checkCode={checkCode}
            history={history}
            selectTerms={selectTerms}
            selectPikerProfile={selectPikerProfile}
            onChange={onChange}
            isChecked={isChecked}
            isFocused={isFocused}
            isEmpty={isEmpty}
            year={year}
            month={month}
            gender={gender}
            setGender={setGender}
            day={day}
            maxDateCalendar={maxDateCalendar}
            picture={picture}
            setPicture={setPicture}
            email={email}
            setEmail={setEmail}
            nameUser={nameUser}
            setNameUser={setNameUser}
            sendRegisterUser={sendRegisterUser}
            latsNameUser={latsNameUser}
            setLatsNameUser={setLatsNameUser}
            password={password}
            setPassword={setPassword}
            ubication={ubication}
            setUbication={setUbication}
            file={file}
            setFile={setFile}
            urlProfilePicture={urlProfilePicture}
            seturlProfilePicture={seturlProfilePicture}
            phone={phone}
            setPhone={setPhone}
            referalcode={referalcode}
            setReferalode={setReferalode}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            error={error}
            setError={setError}
            isAcceptTerms={isAcceptTerms}
            setIsAcceptTerms={setIsAcceptTerms}
            date={date}
            setDate={setDate}
            dateView={dateView}
            setDateView={setDateView}
            isVisibleCalendar={isVisibleCalendar}
            setIsVisibleCalendar={setIsVisibleCalendar}
            refVisibleCalendar={refVisibleCalendar}
            isValidate={isValidate}
            setValidate={setValidate}
            originCity={originCity}
            setOriginCity={setOriginCity}
            currentCity={currentCity}
            setCurrentCity={setCurrentCity}
            isShowModalTerms={isShowModalTerms}
            setIsShowModalTerms={setIsShowModalTerms}
            isShowPikerProfilePicture={isShowPikerProfilePicture}
            setIsShowPikerProfilePicture={setIsShowPikerProfilePicture}
            setiIsCodeReferal={setiIsCodeReferal}
            isCodeReferal={isCodeReferal}
            cleanCodeReferal={cleanCodeReferal}
        />
    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        registerUser: state.register.registerUser, // y lo que retorna map, connect lo envia a Page como Props 
        emailUser: state.register.email,
        code: state.register.code,
    }
}

export default connect(mapStateToProps, { cleanCodeReferal,fileUploadProfileImage, sendRegisterUser ,checkCodeReferal    })(RegisterUser)